import { calculateWordCount } from "../content-details-sections/word-count";
import { Analysis } from "../resume-analysis/resume-analyse-types";



export const getMistakesInStatement = (descriptionAnalysis: Analysis) => {
    if (!descriptionAnalysis || Object.keys(descriptionAnalysis).length === 0) {
        return 0;
    }
    let count = 0;
    if (descriptionAnalysis.actionVerbAnalysis.some(verb => verb.isPastTense === 0)) count++;
    count += descriptionAnalysis.grammarMistakes.length;
    count += descriptionAnalysis.spellingMistakes.length;
    count += descriptionAnalysis.isPassiveVoice === 1 ? 1 : 0;
    count += descriptionAnalysis.endsWithPeriod === 0 ? 1 : 0;
    count += descriptionAnalysis.personalPronouns.length > 0 ? 1 : 0;
    count += descriptionAnalysis.buzzWords.length;
    return count;
}
